import { httpsCallable } from 'firebase/functions';
import { FirebaseError } from 'firebase/app';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import { functions } from '../../../../../../config/firebase';
import { Filter } from '../../../../../domain/interfaces/PaginationBaseInterface';
import {
    fetchUsersStartReducer,
    fetchUsersSuccessReducer,
    fetchUsersFailureReducer,
    setCurrentPageReducer,
    setFilterReducer,
    fetchUsersTreeReferralsSuccessReducer,
    exportUsersStartReducer,
    exportUsersSuccessReducer,
    exportUsersFailureReducer,
} from '../slice/UserSlice'
import { ResponseUserInterface, ResponseUserTreeReferralsInterface, RequestUserTreeReferralsInterface, RequestUserInterface } from "../../domain/interfaces/UserInterface";

const useUserInfrastructure = () => {
    const dispatch = useAppDispatch();
    const userState = useAppSelector((state) => state.user);

    const getUsersListCallable = httpsCallable<RequestUserInterface, ResponseUserInterface>(functions, 'getUsersList');
    const getUserTreeReferralsCallable = httpsCallable<RequestUserTreeReferralsInterface, ResponseUserTreeReferralsInterface>(functions, 'getUserTreeReferrals');
    const getAllUsersListCallable = httpsCallable<RequestUserInterface, ResponseUserInterface>(functions, 'getAllUsersList');

    const fetchUsersInfrastructure = async (page?: number) => {
        dispatch(fetchUsersStartReducer());
        try {
            const targetPage = page ?? userState.pagination.currentPage;
            const lastVisibleId = userState.paginationRequest.pageCursors[targetPage] ?? null;
            
            const request = {
                ...userState.paginationRequest,
                lastVisibleId: lastVisibleId,
            };
            
            const result = await getUsersListCallable(request);
            dispatch(fetchUsersSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchUsersFailureReducer(errorMessage));
        }
    };

    const setCurrentPageInfrastructure = (page: number) => {
        dispatch(setCurrentPageReducer(page))
    }

    const getUserTreeReferralsInfrastructure = async (userId: string | null) => {
        dispatch(fetchUsersStartReducer());
        try {
            const candidateName = process.env.REACT_APP_CANDIDATE_NAME || "Alejandro Ospina";
            const result = await getUserTreeReferralsCallable({ userId, candidateName });
            dispatch(fetchUsersTreeReferralsSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchUsersFailureReducer(errorMessage));
        }
    };

    const setFilterInfrastructure = (filter: Filter) => {
        dispatch(setFilterReducer(filter))
    }

    const applySearchInfrastructure = async () => {
        dispatch(setCurrentPageReducer(1));
        dispatch(fetchUsersStartReducer());

        try {
            const request = {
                ...userState.paginationRequest,
                lastVisibleId: null,
            };
            const result = await getUsersListCallable(request);
            dispatch(fetchUsersSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchUsersFailureReducer(errorMessage));
        }
    };

    const exportUsersInfrastructure = async () => {
        dispatch(exportUsersStartReducer());
        try {
             const request = {
                ...userState.paginationRequest,
                lastVisibleId: null,
            };
            const result = await getAllUsersListCallable(request);
            dispatch(exportUsersSuccessReducer());
            return result.data.users;
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(exportUsersFailureReducer(errorMessage));
            return null;
        }
    };

    return {
        fetchUsersInfrastructure,
        setCurrentPageInfrastructure,
        getUserTreeReferralsInfrastructure,
        applySearchInfrastructure,
        setFilterInfrastructure,
        exportUsersInfrastructure,
        userState
    }
}

export default useUserInfrastructure;